import { omit } from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";

import { Button, ButtonProps } from "./Button";
import { Loading } from "./Loading";
import { theme } from "./theme";

interface LoadingProps {
  loading?: boolean;
}
type StatefulButtonProps = ButtonProps & LoadingProps;

export class StatefulButton extends React.Component<StatefulButtonProps> {
  render() {
    const { children, loading, disabled, ...props } = this.props;
    const selectedProps = omit(props, ["disabled", "loading"]);
    return (
      <Button {...selectedProps} disabled={disabled || loading}>
        <StatefulButtonContent>
          {loading ? (
            <Loading
              color={
                props.buttontype === "primary" ? theme.white : theme.lightGray
              }
            />
          ) : undefined}
          <ButtonContent hide={!!loading}>{children}</ButtonContent>
        </StatefulButtonContent>
      </Button>
    );
  }
}

const StatefulButtonContent = styled.div`
  position: relative;
  ${Loading} {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ButtonContent = styled.div<{ hide?: boolean }>`
  ${(props) =>
    props.hide &&
    css`
      visibility: hidden;
    `};
`;
